import SourceSansProRegular from '../../assets/fonts/SourceSansPro-Regular.ttf';
import SourceSansProSemiBold from '../../assets/fonts/SourceSansPro-SemiBold.ttf';
import SourceSansProBold from '../../assets/fonts/SourceSansPro-Bold.ttf';

export const FONTS = {
  'SourceSansPro-Regular': SourceSansProRegular,
  'SourceSansPro-SemiBold': SourceSansProSemiBold,
  'SourceSansPro-Bold': SourceSansProBold,
};

export const THEME = {
  fonts: {
    default: {
      normal: { name: 'SourceSansPro-Regular', weight: '400' as '400' },
      medium: { name: 'SourceSansPro-SemiBold', weight: '500' as '500' },
      bold: { name: 'SourceSansPro-Bold', weight: '700' as '700' },
    },
  },
  roundness: 8,
};
